// 深色
const darkTheme = {
  '--main-bgc': 'linear-gradient(183deg,#f9fbfc 28%, #f4f5f5 92%, #fbf5f4 92%)',
  // '--main-bgc': '#202020',
  '--main-fontc': '#24282C',
}

export default darkTheme
